/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useState }             from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
}                                      from '@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }         from '../config'

import { node_server }                 from '../Helpers'
import PropTypes                       from 'prop-types'

const HistoryCitationCreateComponent = ({ action }) => {

   const [ citation,    setCitation ]  =  useState('')
   const [ link,        setLink     ]  =  useState('')

   const changeCitation = (c) => {
      setCitation(c.target.value)
   }

   const changeLink = (c) => {
      setLink(c.target.value)
   }

   const handleSubmit = () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.post(node_server + 'historyCitation', {
         citation,
         link
      })
      .then( res => {
         if (res.data.msg === 'good_operation') {
            setCitation('')
         }
      } )
      .catch( (error) => {
         console.error(error)
      })
   }

   return (
      <Box style={{ marginTop: '6rem' }} >
         <Grid>
            <TextField data-testid="history-create-citation" name='history-create-citation' label="History Citation" variant='outlined' value={citation} style={{ width: '40%' }} onChange={changeCitation} />
         </Grid>
         <Grid style={{ marginTop: '1rem' }} >
            <TextField data-testid="history-create-link" name='history-create-link' label="History Link" variant='outlined' value={link} style={{ width: '40%' }} onChange={changeLink} />
         </Grid>
            {citation.length > 0
               ?
                  <Grid item style={{ marginTop: '1rem' }}>
                     <Button data-testid='history-create-citation-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
                  </Grid>
               :
                  <Grid item style={{ marginTop: '1rem' }}>
                     <Button variant='contained' color='primary' disabled>Submit</Button>
                  </Grid>
            }
      </Box>
   )
}

export default HistoryCitationCreateComponent

HistoryCitationCreateComponent.propTypes = {
   action:   PropTypes.string
}